import { useParams } from 'react-router-dom';
import SingleEmployeeBreadcrumbs from 'domain/people/employee/shared/SingleEmployeeBreadcrumbs';
import { DocumentTemplatingWithPreview } from 'domain/shared/documentStorage';
import { useEmployeeService, useEmployeeUrl } from 'domain/shared/employee';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { DEFAULT_ENTITY_AUTHOR } from 'domain/shared/core/constants';
import { EntityHeader, EntityProfileLayout, ShowPageLayout } from 'framework/ui/layout';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE, FormShowTemplate } from 'framework/form';
import EmployeeDocumentBreadcrumbItem from '../shared/EmployeeDocumentBreadcrumbItem';
import ViewEmployeeDocumentDetails from './ViewEmployeeDocumentDetails';
import EmployeeDocumentViewActions from '../shared/buttons/actions/EmployeeDocumentViewActions';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { isEmployeeContractByType, isPolishOffice } from 'domain/shared/employee';

const ViewEmployeeDocument = ({ isEmpoyeePortal: isMyProfile }: { isEmpoyeePortal?: boolean }) => {
  const currentAlias = useEmployeeId()!;
  const { documentPath } = useParams();
  const { addMessageAndRedirect } = useMessageService();
  const { getById } = useEmployeeService();
  const { getEmployeeDocumentsUrl, getSingleEntityUrl } = useEmployeeUrl();
  const { getDocumentByPaths } = useDocumentStorageContext();

  const decodedDocumentPath = decodeURIComponent(documentPath!);

  const getShowData = async () => {
    try {
      const employee = await getById(currentAlias);
      const documentData = (await getDocumentByPaths([decodedDocumentPath]))[0];

      const isPolishContractEmployee =
        employee &&
        isPolishOffice(String(employee.officeId)) &&
        isEmployeeContractByType(String(employee.contractType));

      return {
        nameEn: employee.nameEn,
        documentPath: decodedDocumentPath,
        isPolishContractEmployee,

        ...documentData,
        // For EntityHeader
        createdAt: documentData.metadata.createdAt,
      };
    } catch {
      return addMessageAndRedirect(
        new ErrorMessage(DEFAULT_ERROR_MESSAGE),
        isMyProfile ? getSingleEntityUrl('me') : getEmployeeDocumentsUrl(),
      );
    }
  };

  return (
    <FormShowTemplate
      getDataFunc={getShowData}
      submitFormFunc={async () => {
        // TODO Update File / Config
      }}
      afterSubmit={{
        message: 'You are awesome! The Document has been successfully updated.',
      }}
    >
      <ShowPageLayout
        breadcrumbs={
          !isMyProfile ? (
            <SingleEmployeeBreadcrumbs>
              <EmployeeDocumentBreadcrumbItem filePath={decodedDocumentPath} />
            </SingleEmployeeBreadcrumbs>
          ) : null
        }
        entityHeader={<EntityHeader hasAuthor={false} defaultAuthor={DEFAULT_ENTITY_AUTHOR} />}
        hasSeparateSections
      >
        <EntityProfileLayout
          leftColumnElement={<ViewEmployeeDocumentDetails />}
          rightColumnElement={<DocumentTemplatingWithPreview actions={<EmployeeDocumentViewActions />} />}
        />
      </ShowPageLayout>
    </FormShowTemplate>
  );
};

export default ViewEmployeeDocument;
